import SubHeader from "@src/app/components/SubHeader";
import clsx from "clsx";
import React from "react";

type StaticSectionProps = {
  title: string;
  children: React.ReactNode;
  noIcon?: boolean;
  className?: string;
};

export default function StaticSection({
  title,
  children,
  noIcon = true,
  className,
}: StaticSectionProps) {
  return (
    <>
      <SubHeader title={title} noIcon={noIcon} />
      <div className={clsx("px-3", className)}>{children}</div>
    </>
  );
}
